import { Guid } from 'guid-typescript';
import { IdTagUserType } from 'src/app/shared/enums/id-tag-user-type.enum';

export class UpdateChargingUserRequest {
  departmentId: number;
  name: string;
  emailAddress: string;
  phoneNumber: string;
  idTagShippingAddress?: string;
  idTagUserType: IdTagUserType;
  alias: string;
  invoicingAccountNumber?: number;
  agreementNumber?: number;
  phoneCountryCode: number;
  darId: string;
}
